import {
    UPDATE_EDIT_CONSULTATION_DETAILS,
    SAVE_EDIT_PRESCRIPTION_TEMPLATES_RESPONSE,
    CLEAR_EDIT_PRESCRIPTION_DETAILS,
    FETCH_EDIT_PRESCRIPTION_DETAILS_SUCCESS,
    SAVE_EDIT_SUB_SECTIONS_RECOMMENDATIONS,
    UPDATE_EDIT_CURRENT_CONSULTATION_DATA,
    UPDATE_EDIT_SUGGESTIONS_CONSULTATION_DATA,
    STORE_APPLIED_TEMPLATES_EDIT,
    REMOVE_APPLIED_TEMPLATES_EDIT
} from "../actions/ActionTypes"
import initialState from "./InitialState"
import { removeFieldsForId } from "../utils/AppUtils";

export const EditPrescriptionReducer = (state = initialState.editPrescription, action: any) => {
    switch (action.type) {
        case FETCH_EDIT_PRESCRIPTION_DETAILS_SUCCESS:
            return { ...state, ...action.consultationData };
        case UPDATE_EDIT_CONSULTATION_DETAILS:
            return { ...state, ...action.payload };
        case SAVE_EDIT_PRESCRIPTION_TEMPLATES_RESPONSE:
            return {...state, pdfTemplates: action.payload}
        case CLEAR_EDIT_PRESCRIPTION_DETAILS:
            return {}
        case SAVE_EDIT_SUB_SECTIONS_RECOMMENDATIONS:
            return {...state, suggestions: {...state.suggestions, ...action.payload}}
        case UPDATE_EDIT_SUGGESTIONS_CONSULTATION_DATA:
            return {  ...state, suggestions: { ...state.suggestions, treatmentPlan: action.payload } }
        case UPDATE_EDIT_CURRENT_CONSULTATION_DATA:
            return {  ...state, medicalProfile: { ...state.medicalProfile, currentConsultationData: action.medicalProfile } }
        case STORE_APPLIED_TEMPLATES_EDIT:
            const appliedTemplateIds = state.medicalProfile?.currentConsultationData?.prescriptionTemplateMapping?.templateIds || [];
            if (!appliedTemplateIds.includes(action.templateId)) {
                appliedTemplateIds.push(action.templateId);
            }
            return {
                ...state,
                medicalProfile: {
                    ...state.medicalProfile,
                    currentConsultationData: {
                        ...state.medicalProfile.currentConsultationData,
                        prescriptionTemplateMapping: {
                            ...state.medicalProfile?.currentConsultationData?.prescriptionTemplateMapping,
                            templateIds: appliedTemplateIds
                        }     
                    } 
                }
            }

        case REMOVE_APPLIED_TEMPLATES_EDIT:
            const newTemplateIds = state.medicalProfile?.currentConsultationData?.prescriptionTemplateMapping?.templateIds || [];
            const removeTemplateIndex = newTemplateIds.indexOf(action.templateId);
            let newPrescription = state.medicalProfile.currentConsultationData;
            
            const newReferenceIds = state.medicalProfile?.currentConsultationData?.prescriptionTemplateMapping?.referenceIds || [];
            const removereferenceIndex= newReferenceIds.indexOf(action.templateId);
            if (removereferenceIndex !== -1) {
                newReferenceIds.splice(removereferenceIndex, 1);
                newPrescription = removeFieldsForId(state.medicalProfile.currentConsultationData, action.templateId);
            }
            if (removeTemplateIndex !== -1) {
                newTemplateIds.splice(removeTemplateIndex, 1);
                newPrescription = removeFieldsForId(newPrescription, action.templateId);
            }
            return {
                ...state,
                medicalProfile: {
                    ...state.medicalProfile,
                    currentConsultationData: newPrescription
                }
            };

        default:
            return state;
    }
}